import Error from "next/error";
import { parseCookies } from "nookies";
import {
  exportPageType,
  exportPageVersion,
  trackPageView,
} from "../utils/Fetch/Analytics";
import * as query_string from "query-string";
import { useEffect } from "react";

function ErrorPage({ statusCode }) {
  return <Error statusCode={statusCode} />;
}

ErrorPage.getInitialProps = (ctx) => {
  const statusCode = ctx.res
    ? ctx.res.statusCode
    : ctx.err
    ? ctx.err.statusCode
    : 404;

  const url = ctx.asPath;
  const pageType = exportPageType(ctx.pathname);
  const pageVersion = exportPageVersion(ctx.pathname);

  const cookies = parseCookies(ctx);
  const parameters = query_string.stringify(ctx.query);

  trackPageView({
    lead_uuid: cookies.lead_uuid,
    session_uuid: cookies.rea_session_uuid,
    parameters,
    page: url,
    pageType,
    pageVersion,
    statusCode,
    ctx,
  });

  return { statusCode };
};

export default ErrorPage;
